import { useEffect, useState } from 'react'

/** Muss zur Dauer in `RightSidebar.scss` und am Motion-Block in `MainLayout.scss` passen. */
export const RIGHT_SIDEBAR_MOTION_MS = 200

/**
 * Ob die rechte Seitenleiste gerade **umgeschaltet** wird (#277) — dann zieht die Inhaltskarte
 * ihren rechten Rand im selben Takt mit (`main-layout--right-sidebar-motion`).
 *
 * Nur beim Umschalten, nicht dauerhaft: Beim Tab-Wechsel von oder zu „Ziele“ wird das Panel ein-
 * bzw. ausgehängt und erscheint ohne Bewegung. Stünde `margin-right` immer im Übergang, rutschte der
 * Rand dort 200 ms nach, während das Panel längst weg ist.
 *
 * Umschalten heißt: `visible` wechselt, während das Panel vorher UND nachher verfügbar ist. Die
 * Phase wird im Render abgeleitet wie in `usePeekExit` — Klasse und Randwechsel landen so in
 * derselben DOM-Änderung; ein Effekt käme ein Bild zu spät, der Rand spränge noch.
 */
export function useRightSidebarMotion(visible: boolean, available: boolean): boolean {
  // 0 = Ruhe, sonst die laufende Bewegung. Gezählt statt Ja/Nein: Schaltet man mitten in einer
  // Bewegung zurück, beginnt eine neue — der Timer muss neu starten, sonst fiele die Klasse
  // mitten in ihr weg und der Rand spränge ans Ziel.
  const [motion, setMotion] = useState(0)
  const [last, setLast] = useState({ visible, available })

  if (last.visible !== visible || last.available !== available) {
    setLast({ visible, available })
    setMotion(last.available && available && last.visible !== visible ? motion + 1 : 0)
  }

  useEffect(() => {
    if (!motion) return
    const timer = setTimeout(() => setMotion(0), RIGHT_SIDEBAR_MOTION_MS)
    return () => clearTimeout(timer)
  }, [motion])

  return motion > 0
}
